module.exports = __webpack_public_path__ + "static/img/natasha_pictgrid13_1020x842.31f1031.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/natasha_pictgrid13_1020x842.jpg
// module id = OLav
// module chunks = 0